import { render, staticRenderFns } from "./TypeformQuestionHolder.vue?vue&type=template&id=57f948fb&scoped=true&"
import script from "./TypeformQuestionHolder.vue?vue&type=script&lang=js&"
export * from "./TypeformQuestionHolder.vue?vue&type=script&lang=js&"
import style0 from "./TypeformQuestionHolder.vue?vue&type=style&index=0&id=57f948fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f948fb",
  null
  
)

export default component.exports